<script setup lang="ts">
import { PV } from "@/widgets";
import { isString } from "es-toolkit";
import { unref, type Component, type MaybeRef } from "vue";

const props = defineProps<{
    label?: string;
    icon?: Component | string;
    severity?: "secondary" | "success" | "info" | "warn" | "help" | "danger" | "contrast";
    isLoading?: MaybeRef<boolean>;
}>();
</script>

<template>
    <PV.Button :disabled="unref(props.isLoading) === true" :severity="props.severity" type="button">
        <span class="inline-flex flex-row items-center gap-1">
            <i v-if="unref(props.isLoading) === true" class="pi pi-spin pi-spinner mr-1" style="font-size: 1rem" />
            <template v-if="props.icon !== undefined">
                <i v-if="isString(props.icon)" class="mr-1" :class="props.icon" />
                <component :is="props.icon" v-else />
            </template>
            <span class="font-semibold">{{ props.label ?? "Simpan" }}</span>
        </span>
    </PV.Button>
</template>
